import { Button, EmptyState } from "@nexus/ui"
import { useTranslation } from "react-i18next"

export interface OpportunitiesErrorStateProps {
  onRetry?: () => void
}

export function OpportunitiesErrorState({ onRetry }: OpportunitiesErrorStateProps) {
  const { t } = useTranslation()

  return (
    <EmptyState
      variant="error"
      title={t("opportunities.errorTitle")}
      description={t("opportunities.errorDescription")}
      action={
        onRetry ? (
          <Button variant="outline" onClick={onRetry}>
            {t("common.retry")}
          </Button>
        ) : undefined
      }
    />
  )
}
